import type { HTMLAttributes, ReactElement } from 'react';

import { classNames } from '@m1work/shared-utils';

import styles from './Menu.module.scss';

export type MenuProps = HTMLAttributes<HTMLDivElement>;

/**
 * A vertical list of actions, e.g. the account menu in a popover. Fill it with `MenuItem`.
 *
 * @example
 * <Menu>
 *     <MenuItem icon={<SettingsIcon />} asChild>
 *         <a href={settingsUrl}>{t('menu.settings')}</a>
 *     </MenuItem>
 *     <MenuItem icon={<LogOutIcon />} color="error" onClick={logout}>{t('menu.logout')}</MenuItem>
 * </Menu>
 */
export function Menu({ className, children, ...props }: MenuProps): ReactElement {
    return (
        <div role="menu" className={classNames(styles.menu, className)} {...props}>
            {children}
        </div>
    );
}
